<template>
    <div>
         <nav-bar-main v-if="$store.state.userLastPlants.length >0"></nav-bar-main>
         <Loader />  
         <div class="animated fadeIn mt-3">
            
            <!-- titolo supporto --> 
            <b-row >                 
                <b-col cols="6">
                    <div id="title-first" class="ml-5 mt-2 typo-label">
                        <i class="fa fa-question-circle pr-1 pt-1 fa-1x pull-left"></i>
                        <span>{{$t("supportPage.title")}}: <b>{{$t("supportPage.data")}}</b></span>
                    </div>
                </b-col>
            </b-row>

            <!-- card support --> 
            <b-card class="mx-4 mt-2 radius-card" id="sezione-supporto">
                <div id="title-first"><b>{{$t("supportPage.invitecollab?")}}</b></div>  
                <div id="title-first">{{$t("supportPage.invitecollab")}}</div>  
            </b-card>
            <b-card class="mx-4 mt-2 radius-card" id="sezione-supporto">
                <div id="title-first"><b>{{$t("supportPage.inviteclient?")}}</b></div>  
                <div id="title-first">{{$t("supportPage.inviteclient")}} </div>  
            </b-card>
            <b-card class="mx-4 mt-2 radius-card" id="sezione-supporto">
                <div id="title-first"><b>{{$t("supportPage.newplant?")}}</b></div>  
                <div id="title-first">{{$t("supportPage.newplant")}} </div>  
            </b-card>
            <b-card class="mx-4 mt-2 radius-card" id="sezione-supporto">
                <div id="title-first"><b>{{$t("supportPage.profile?")}}</b></div>  
                <div id="title-first">{{$t("supportPage.profile")}} </div>  
            </b-card>
            <b-card class="mx-4 mt-2 radius-card" id="sezione-supporto">
                <div id="title-first"><b>{{$t("supportPage.canceluser?")}}</b></div>  
                <div id="title-first">{{$t("supportPage.canceluser")}} nube@beghelli.it</div>  
            </b-card>

         </div>
  </div>
</template>


<script>

import Vue from 'vue';
import NavBarMain from '@/components/NavBarMain';
import { mapState } from 'vuex';

export default {
    name: 'Supporto',
    components: {
        NavBarMain,
    },
    data() {
        return {
          }
    },
    computed: {
    }
}

</script>

<style lang="scss">


</style>